<template>
	<div class="footer3" ref="footer3">
        <img :src="bottomGzh" alt="" width="247px"/>
       <div v-html="bottomDesc"></div> 
    </div>
</template>
<style scoped>
	.footer3{text-align: center;padding-top:17px;padding-bottom:10px;background:#fff;}
    .footer3 p{font-size:0.16rem;margin-top:7px;}

	.fixed-bottom{position: fixed;bottom: 0;width:100%;}
</style>
<script>
	import axios from "axios";
	import config from "@/api/base.js";
	export default{
				data(){
			return{
                bottomGzh:'',                    //底部公众号
                bottomDesc:'',                    //底部文字
			}
		},
		
		mounted(){
		    var winHeight = window.innerHeight; //可视窗口高度，不包括浏览器顶部工具栏
		    var a=$(this.$refs.footer3).height();
		    var heig=winHeight-a-50;
		    $(".main").css("minHeight",heig);
		    $("body").css("scrollTop",'0');
		    
		        //首页下载链接
       
                var _this=this;
                var params={};
                axios.post('/info/getAppDownUrl.html',params,config)
                .then(function(res){
      
                   _this.bottomGzh=res.data.bottomGzh;
                     _this.bottomDesc=res.data.bottomDesc;
                });
           
		}
	}
</script>


// WEBPACK FOOTER //
// footer.vue?805ffe18